// Geteilte Framer-Motion-Bausteine für das Team-Dashboard.
// Ziel: ruhige, "edle" App-Animationen wie auf einem iPhone – keine übertriebenen
// Effekte, sondern sanftes Ein-/Ausblenden plus ein leichtes Anheben der Inhalte.

// Apples bekannte Ease-Kurve (gleitet schnell an, bremst weich aus).
export const easeIOS = [0.32, 0.72, 0, 1];

// ── Seiten-Übergang zwischen den Tabs (Out → In) ──────────────────────────
// Wird in <AnimatePresence mode="wait"> verwendet, sodass die alte Seite sauber
// rausgleitet, bevor die neue reinkommt. Bewusst nur ein zartes Cross-Fade mit
// minimalem Versatz – KEIN Skalieren des großen Scroll-Containers (das würde das
// ganze Panel "zoomen" lassen). Die eigentliche Eleganz macht der innere Stagger.
export const pageVariants = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 0.3, ease: easeIOS },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.14, ease: easeIOS },
  },
};

// ── Container, der seine Kinder gestaffelt erscheinen lässt ────────────────
// Für Seiten/Bereiche, die ihren eigenen Stagger steuern (z. B. die Spalten
// eines Boards), unabhängig vom Seiten-Übergang.
export const staggerContainer = {
  initial: {},
  animate: {
    transition: { delayChildren: 0.05, staggerChildren: 0.07 },
  },
};

// ── Einzelner Container / Karte / Abschnitt – tritt sanft von unten herein ─
export const itemVariants = {
  initial: { opacity: 0, y: 16 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: easeIOS },
  },
};

// Etwas zarter, für viele kleine Elemente (Listenzeilen, Spalten).
export const subtleItemVariants = {
  initial: { opacity: 0, y: 10 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: easeIOS },
  },
};
